(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('DiscountRateDialogController', DiscountRateDialogController);

    DiscountRateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DiscountRate'];

    function DiscountRateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DiscountRate) {
        var vm = this;
        vm.discountRate = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:discountRateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.discountRate.id !== null) {
                DiscountRate.update(vm.discountRate, onSaveSuccess, onSaveError);
            } else {
                DiscountRate.save(vm.discountRate, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
